<template>
  <div class="ptStarka-aboutUs">
    <menuBox :step="2"></menuBox>
    <div class="content-top">
      <div class="title">Dari konsepsi hingga produk jadi, kami bersedia bekerja sama dengan Anda untuk menulis babak
        baru dalam film dan televisi.</div>
      <div class="text">Rumah/Tentang Kami</div>
    </div>
    <div class="info-box">
      <div class="item">
        <div class="left">
          <img src="../assets/about1.png" class="about1" />
          <div class="box">
            <div class="times">
              <img src="../assets/time.png" />
              <span>10 Mar 2024</span>
            </div>
            <div class="leftTitle">Rumah kecil yang nyaman tempat Anda bisa menikmati menonton film bersama dan
              menciptakan kenangan indah.</div>
            <div class="leftText">Dalam adegan saat keluarga sedang bersantai, kami dapat menyediakan film rumahan yang
              disesuaikan untuk acara kumpul keluarga atau menyediakan film yang cocok untuk ditonton keluarga, merekam
              momen bahagia anggota keluarga, sehingga setiap keluarga dapat memiliki film rumahan masing-masing.</div>
          </div>
        </div>
        <div class="right">
          <div class="bt">Search Objects</div>
          <div class="line"></div>
          <div class="inputBox">
            <input type="text" placeholder="Search">
            <img src="../assets/about2.png" />
          </div>

        </div>
      </div>
      <div class="item">
        <div class="left">
          <img src="../assets/about3.png" class="about1" />
          <div class="box">
            <div class="times">
              <img src="../assets/time.png" />
              <span>10 Mar 2024</span>
            </div>
            <div class="leftTitle">Kencan dan film romantis membuat cinta menjadi lebih manis.</div>
            <div class="leftText">Dalam adegan kencan pasangan, kita dapat merekam film mikro cinta bagi pasangan untuk
              merekam kisah cinta mereka agar cinta mereka lebih romantis dan tak terlupakan, dan menampilkan kisah
              cinta mereka di layar untuk membuat cinta mereka lebih romantis dan berkesan . Ia juga dapat memberikan
              pasangan video yang dapat ditonton untuk menambah suasana manis cinta.</div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <img src="../assets/about4.png" class="about1" />
          <div class="box">
            <div class="times">
              <img src="../assets/time.png" />
              <span>10 Mar 2024</span>
            </div>
            <div class="leftTitle">Bersantailah dengan film dan nikmati setiap momen dalam hidup Anda.</div>
            <div class="leftText">Dalam konteks kumpul teman, memilih kami tidak hanya menambah keseruan momen kumpul
              teman Anda, tapi juga membuat hidup Anda lebih berwarna.</div>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "services" });
    },
  },
};
</script>
<style lang="less" scoped>
.content-top {
  background-image: url(../assets/about.png);
  width: 100%;
  height: 640px;
  background-size: 100% 100%;
  padding: 200px 312px 0 312px;
  overflow: hidden;
  box-sizing: border-box;
  text-align: center;

  .title {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 56px;
    color: #FFFFFF;
    line-height: 79px;
  }

  .text {
    font-size: 24px;
    color: #E5D806;
    line-height: 33px;
  }
}

.info-box {
  padding: 70px 312px;
  background: #1E1D21;

  .item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 64px;

    .left {
      .about1 {
        width: 856px;
        height: 482px;
      }

      .box {
        width: 856px;
        padding: 30px 32px;
        background: #393939;
        box-sizing: border-box;
      }

      .times {
        margin-bottom: 10px;

        img {
          margin-right: 8px;
          width: 12px;
          height: 12px;
        }

        span {
          font-size: 14px;
          color: #FFFFFF;
          line-height: 16px;
        }
      }

      .leftTitle {
        margin-bottom: 24px;
        font-weight: 700;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 33px;
      }

      .leftText {
        font-size: 16px;
        color: #FFFFFF;
        line-height: 18px;
      }
    }

    .right {
      padding: 32px;
      background: #393939;

      .bt {
        margin-bottom: 12px;
        font-weight: 700;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 26px;
      }

      .line {
        margin-bottom: 30px;
        width: 40px;
        height: 3px;
        background: #E5D806;
      }

      .inputBox {
        display: flex;
        align-items: center;

        input {
          padding: 20px;
          width: 268px;
          height: 55px;
          background: #5C5C5C;
          border: none;
          box-sizing: border-box;
        }

        img {
          width: 55px;
          height: 55px;
          cursor: pointer;
        }
      }
    }
  }

}
</style>
